import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {SearchTaskCalendarClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL
const searchTaskCalendarClient = new SearchTaskCalendarClient(SERVICE_URL)

const initialState = {
  loading: false,
  error: null,
  calendar: null,
}

export const taskCalendarGetAll = createAsyncThunk('taskCalendar/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await searchTaskCalendarClient.getAll(params)
    dispatch(setCalendarList(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

const taskCalendarSlice = createSlice({
  name: 'taskCalendar',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setCalendarList: (state, action) => {
      state.calendar = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('taskCalendar/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

export const {setLoading, setError, setCalendarList, resetState} = taskCalendarSlice.actions

export const selectTaskCalendarList = (state) => state.taskCalendar.calendar
export const selectTaskCalendarLoading = (state) => state.taskCalendar.loading
export const selectTaskCalendarError = (state) => state.taskCalendar.error

export default taskCalendarSlice.reducer
